import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Text,
  Container,
  Flex,
  Heading,
  Spinner,
} from '@chakra-ui/react';
import { CloseIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { animated as a, useSpring } from 'react-spring';

import PropTypes from 'prop-types';
import axios from 'axios';
import { graphql } from 'gatsby';
import { useForm } from 'react-hook-form';
import {
  LinkEmail, LinkOne, LinkPhone, SEO,
} from '../components/_index';

const seoContent = {
  title: "Contact us - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

const ContactPage = ({ data, location }) => {
  const [waiting, setWaiting] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    type: 'warning',
    message: '',
  });

  // page metadata
  const { site } = data;
  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
    baseUrl,
    defaultImage,
    phone,
    twitterUsername,
  } = site.siteMetadata;

  // form
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    reValidateMode: 'onChange',
  });

  const AlertMessage = ({ message }) => (
    <Alert
      mt={6}
      borderRadius="md"
      status={message.type}
    >
      <Flex justifyContent="space-between">
        <AlertIcon />
        <AlertTitle mr={2} />
        <AlertDescription color="gray.800">{message.message}</AlertDescription>
        <CloseIcon
          color="gray.800"
          onClick={() => setAlertMessage({ type: 'warning', message: '' })}
          ml={4}
        />
      </Flex>
    </Alert>
  );

  const onSubmit = async (leadData) => {
    setWaiting(true);
    console.log('submit all', leadData);
    const results = await axios
      .post('/leads', leadData, {
        baseURL: 'https://odwwt9.deta.dev',
        headers: {
          Accept: '*/*',
          'X-Forwarded-Host': 'odwwt9.deta.dev',
          'X-Forwarded-Proto': 'https',
          'X-Forwarded-Port': '443',
          'Content-Type': 'application/json',
          'X-Scheme': 'https',
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then((res) => {
        console.log('status', res.status);
        setWaiting(false);
        if (res.status === 200) {
          setAlertMessage({
            type: 'success',
            message: 'Thank you, we will be in touch you shortly.',
          });
          return 200;
        }
      })
      .catch((err) => {
        setWaiting(false);
        console.log('status', err.status);
        if (err.status === 401) {
          setAlertMessage({
            type: 'warning',
            message:
              'We already have your info. If you think we missed you, ping us on slack',
          });
          return 401;
        }
        setAlertMessage({
          type: 'error',
          message:
            "Something went wrong. Please try again and if that doesn't work ping us on slack",
        });
      });
    return results;
  };

  return (
    <Box position="relative">
      <SEO
        location={location}
        title={seoContent.title}
        description={seoContent.description}
      />
      <main>
        <Box
          py={40}
          zIndex="3"
        >
          <Container>
            <Heading
              as="h1"
              maxWidth="800px"
              size="3xl"
              lineHeight="base"
              mb={20}
            >
              Contact
            </Heading>
          </Container>

          <Box>
            <Container>
              <Heading
                as="h3"
                size="lg"
                variant="sec"
                mb={5}
                mt={10}
              >
                We would love to hear from you. Please fill out the form and we
                will get in touch shortly.
              </Heading>
            </Container>
            <Container>
              <form
                className="contact start-conversation"
                onSubmit={handleSubmit(onSubmit)}
              >
                <Box
                  display="flex"
                  flexDirection={{ base: 'column' }}
                  className="add-name"
                >
                  <Heading
                    as="h5"
                    size="md"
                    mb={4}
                    variant="sec"
                    lineHeight="base"
                  >
                    What is your name?
                  </Heading>
                  <Flex
                    justifyContent="space-between"
                    flexWrap="wrap"
                    flexDirection={{ base: 'column', md: 'row' }}
                  >
                    <Box
                      flexGrow="1"
                      className="input-name"
                      mr={{ base: '0', md: '4' }}
                    >
                      <label htmlFor="firstname">First Name</label>
                      <input
                        className={errors.firstname ? 'error' : ''}
                        id="firstname"
                        type="text"
                        placeholder="First Name"
                        {...register('firstname', { required: true })}
                      />
                      {errors.firstname
                        && errors.firstname.type === 'required' && (
                          <Text
                            fontSize="sm"
                            color="red.400"
                            backgroundColor="transparent"
                            mr={4}
                          >
                            First name is required
                          </Text>
                      )}
                    </Box>

                    <Box
                      flexGrow="1"
                      className="input-name"
                    >
                      <label htmlFor="lastname">Last Name</label>
                      <input
                        id="lastname"
                        className={errors.lastname ? 'error' : ''}
                        type="text"
                        placeholder="Last Name"
                        {...register('lastname', { required: true })}
                      />
                      {errors.lastname && errors.lastname.type === 'required' && (
                        <Text
                          fontSize="sm"
                          color="red.400"
                          backgroundColor="transparent"
                          mr={4}
                        >
                          Last name is required
                        </Text>
                      )}
                    </Box>
                  </Flex>
                </Box>
                <Box my={6}>
                  <div className="add-email input-container">
                    <Heading
                      as="h5"
                      size="md"
                      mb={4}
                      lineHeight="base"
                      variant="sec"
                    >
                      What is your email?
                    </Heading>
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      className={errors.email ? 'error' : ''}
                      id="email"
                      placeholder="Email"
                      {...register('email', {
                        required: true,
                        maxLength: 45,
                      })}
                    />
                    {errors.email && errors.email.type === 'required' && (
                      <Text
                        fontSize="sm"
                        color="red.400"
                        backgroundColor="transparent"
                        mr={4}
                      >
                        Email is required
                      </Text>
                    )}
                  </div>
                </Box>
                <Box my={6}>
                  <div className="add-email input-container">
                    <Heading
                      as="h5"
                      size="md"
                      mb={4}
                      lineHeight="base"
                      variant="sec"
                    >
                      What is your phone number?
                    </Heading>
                    <label htmlFor="phone">Phone</label>
                    <input
                      type="phone"
                      id="phone"
                      className={errors.phone ? 'error' : ''}
                      placeholder="Phone"
                      {...register('phone', {
                        required: false,
                        maxLength: 45,
                      })}
                    />
                    {errors.phone && errors.phone.type === 'required' && (
                      <Text
                        fontSize="sm"
                        color="red.400"
                        backgroundColor="transparent"
                        mr={4}
                      >
                        Phone number is required
                      </Text>
                    )}
                  </div>
                </Box>
                <Box my={6}>
                  <div className="add-email input-container">
                    <Heading
                      as="h5"
                      size="md"
                      mb={4}
                      lineHeight="base"
                      variant="sec"
                    >
                      Write us a brief message
                    </Heading>
                    <label htmlFor="message">Message</label>
                    <textarea
                      type="message"
                      id="message"
                      className={errors.message ? 'error' : ''}
                      placeholder="What can we help you with?"
                      {...register('message', {
                        required: true,
                        maxLength: 400,
                      })}
                    />
                    {errors.message && errors.message.type === 'required' && (
                      <Text
                        fontSize="sm"
                        color="red.400"
                        backgroundColor="transparent"
                        mr={4}
                      >
                        Message is required
                      </Text>
                    )}
                  </div>
                </Box>
                {waiting ? (
                  <div className="light btn-one">
                    <Spinner size="sm" />
                  </div>
                ) : (
                  <input
                    className="light btn-one"
                    type="submit"
                    value="Submit"
                  />
                )}
              </form>
              <Box minheight="50px">
                {alertMessage.message !== '' ? (
                  <AlertMessage
                    backgroundColor="transparent"
                    message={alertMessage}
                  />
                ) : undefined}
              </Box>
              <Heading
                as="h3"
                size="xl"
                mb={10}
                lineHeight="base"
              />
            </Container>
          </Box>
        </Box>
      </main>
    </Box>
  );
};

export default ContactPage;

ContactPage.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

ContactPage.defaultProps = {
  title: null,
  description: null,
};

export const query = graphql`
  query {
    site {
      siteMetadata {
        author
        baseUrl
        description
        image
        phone
        siteUrl
        title
        titleTemplate
        twitterUsername
      }
    }
  }
`;
